/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function CompanyIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-company">
        <g id="Group 63 Copy 2">
          <g id="Group 61 Copy 2">
            <g id="Group 59 Copy 3">
              <g id="icon-legal and finance copy">
                <g id="Group 58 Copy 2">
                  <g id="icon-journey-course">
                    <circle
                      id="Oval"
                      cx="78.5"
                      cy="78.5"
                      r="77.5"
                      fill={mainColor}
                      stroke="white"
                      stroke-width="2"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="home copy 2">
          <path
            id="Path"
            d="M75.4994 56L42.0587 84.2367C42.0587 84.2766 42.0489 84.3352 42.0293 84.4151C42.0102 84.4944 42 84.552 42 84.5929V113.186C42 114.218 42.3685 115.113 43.1053 115.866C43.8419 116.62 44.7142 116.999 45.7223 116.999H68.0544V94.1243H82.9446V117H105.276C106.284 117 107.158 116.622 107.893 115.866C108.63 115.113 109 114.218 109 113.186V84.5929C109 84.4343 108.979 84.3146 108.941 84.2367L75.4994 56Z"
            fill={secondaryColor}
          />
          <path
            id="Path_2"
            d="M123.331 75.7626L110.155 65.6399V42.9471C110.155 42.4283 109.975 42.0017 109.613 41.6678C109.254 41.3343 108.792 41.1675 108.23 41.1675H96.6784C96.1166 41.1675 95.6553 41.3343 95.2939 41.6678C94.9333 42.0017 94.7532 42.4285 94.7532 42.9471V53.7928L80.0731 42.4461C78.791 41.482 77.2665 41 75.5014 41C73.7365 41 72.2123 41.482 70.9289 42.4461L27.6686 75.7626C27.2675 76.0587 27.0477 76.4573 27.0069 76.958C26.9662 77.4582 27.1063 77.8952 27.4277 78.2657L31.1579 82.3816C31.4793 82.7152 31.8999 82.9191 32.4214 82.9937C32.903 83.0311 33.3845 82.901 33.866 82.6045L75.5002 50.5112L117.135 82.6043C117.456 82.863 117.877 82.9922 118.398 82.9922H118.579C119.1 82.9189 119.52 82.7136 119.843 82.3809L123.573 78.2655C123.894 77.8942 124.035 77.458 123.993 76.9572C123.952 76.4579 123.731 76.0593 123.331 75.7626Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

CompanyIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
CompanyIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(CompanyIcon);
memoized.displayName = 'CompanyIcon';
export default memoized;
